"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const WrapListener = (...listeners) => event => listeners.map(listener => typeof listener === 'function' && listener(event));

var _default = WrapListener;
exports.default = _default;